import { IIconProps } from 'src/interfaces/IconProps';

const ChevronRightIcon = ({ width = 15, height = 20, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 8 16' fill={color} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      // eslint-disable-next-line max-len
      d='M0.158843 0.134474C-0.0430326 0.322891 -0.0539427 0.639286 0.134474 0.841161L6.81606 8L0.134474 15.1588C-0.0539427 15.3607 -0.0430326 15.6771 0.158843 15.8655C0.360718 16.0539 0.677113 16.043 0.86553 15.8412L7.86553 8.34116C8.04483 8.14906 8.04483 7.85095 7.86553 7.65884L0.86553 0.158843C0.677113 -0.0430326 0.360718 -0.0539428 0.158843 0.134474Z'
    />
  </svg>
);

export default ChevronRightIcon;
